import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import fireDB from "../fireconfig";
import { getDoc, doc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import "../assets/css/ProductDetails.scss";

const ProductDetails = () => {
  const [product, setProduct] = useState();
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const productDetails = await getDoc(
        doc(fireDB, "products", params.productid)
      );
      setProduct(productDetails.data());
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const [value, setValue] = useState(1);
  const min = 0;
  const max = 10;

  const handleChange = (event) => {
    const value = Math.max(min, Math.min(max, Number(event.target.value)));
    setValue(value);
  };

  const addToCart = (product) => {
    dispatch({ type: "ADD_TO_CART", payload: product });
  };

  return (
    <Layout loading={loading}>
      {product && (
        <div className="product_details_container">
          <div className="product_details_left">
            <img
              className="product_details_image"
              src={product.image}
              alt={product.title}
            />
            <h1 className="product_details_title">{product.title}</h1>
            <p className="product_details_desscription">
              {product.description}
            </p>
          </div>
          <div className="product_details_right">
            <p>Weight : &nbsp;&nbsp; 200g</p>
            <p>Maximum Shelf Life : &nbsp;&nbsp; 3 Months</p>
            <p className="product_details_price">Price: ₹ {product.price}/-</p>
            <div className="product_details_quantity">
              <p>*Quantity( 1 - 10 ):</p>
              <input
                type="number"
                onWheel={(e) => e.target.blur()}
                value={value}
                onChange={handleChange}
                className="form-control"
              ></input>
            </div>
            <button
              className="btn btn-success"
              onClick={() => addToCart(product)}
            >
              Add to Cart
            </button>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default ProductDetails;
